/**
 * Gallery small slider script
 */
class Bookero_SliderGallerySmall {
  constructor (wrapper) {
    this.gallerySliderWrapper = wrapper;
    this.initEvents();
  }

  initEvents() {
    this.initRWD();
    this.initUI();
  }

  initUI () { 
    this.prevBtn = this.gallerySliderWrapper.find('.prev');
    this.nextBtn = this.gallerySliderWrapper.find('.next');
    this.list = this.gallerySliderWrapper.find('.slider-gallery-small-list');
    this.items = this.list.find('.slider-gallery-small-item');
    this.currentItem = null;
    this.animationInProgress = false;
    this.swipeEffect = new Hammer(this.gallerySliderWrapper[0]);
    this.mobileViewport = window.matchMedia('(max-width: 559px)');

    if(this.mobileViewport.matches) {
      this.currentItem = 0;
      this.prevBtn.addClass('is-disabled');
      this.list.css('margin-left', 0);
    }

    this.prevBtn.on('click', e => {
      e.preventDefault();

      if (this.animationInProgress) {
        return;
      }

      this.currentItem--;

      this.animationInProgress = true;

      if (this.currentItem === 0) {
        this.prevBtn.addClass('is-disabled');
      }

      this.items.removeClass('is-active');
      this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
      this.nextBtn.removeClass('is-disabled');

      setTimeout(() => {
          this.animationInProgress = false;
      }, 250);
    });

    this.nextBtn.on('click', e => {
      e.preventDefault();

      if (this.animationInProgress) {
        return;
      }

      this.currentItem++;
      this.animationInProgress = true;

      if (this.currentItem > (this.items.length - this.itemsPerPage) - 1) {
        this.nextBtn.addClass('is-disabled');
      }

      this.items.removeClass('is-active');
      this.items.eq(this.currentItem).addClass('is-active');
      this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
      this.prevBtn.removeClass('is-disabled');

      setTimeout(() => {
        this.animationInProgress = false;
      }, 250);
    });

    this.swipeEffect.on('swipe', ev => {
      if (ev.type === 'swipe' && ev.direction === 2 && ev.deltaX < -30) {
        if (this.currentItem < this.items.length - 1) {
          this.currentItem++;
        } else {
          this.currentItem = 0;
        }

        this.nextBtn.click();
      }

      if (ev.type === 'swipe' && ev.direction === 4 && ev.deltaX > 30) {
        if (this.currentItem > 0) {
          this.currentItem--;
        } else {
          this.currentItem = this.items.length - 1;
        }

        this.prevBtn.click();
      }
    });
  }

  initRWD () {
    this.desktopViewport = window.matchMedia('(min-width: 841px)');
    this.tabletViewport = window.matchMedia('(min-width: 560px) and (max-width: 840px)');
    this.mobileViewport = window.matchMedia('(max-width: 559px)');
    if (this.desktopViewport.matches) this.updateViewports('desktop');
    if (this.tabletViewport.matches) this.updateViewports('tablet');
    if (this.mobileViewport.matches) this.updateViewports('mobile');
    this.desktopViewport.addListener(mq => mq.matches ? this.updateViewports('desktop') : false);
    this.tabletViewport.addListener(mq => mq.matches ? this.updateViewports('tablet') : false);
    this.mobileViewport.addListener(mq => mq.matches ? this.updateViewports('mobile') : false);
    this.prevBtn = this.gallerySliderWrapper.find('.prev');
    this.nextBtn = this.gallerySliderWrapper.find('.next');
    this.list = this.gallerySliderWrapper.find('.slider-gallery-small-list');
    this.items = this.list.find('.slider-gallery-small-item');

    if (this.desktopViewport.matches) {
      this.itemsPerPage = 4;

      if(this.items.length <= 4) {
        this.nextBtn.addClass('is-disabled');
      }
    } else if (this.tabletViewport.matches) {
      this.itemsPerPage = 2;

      if(this.items.length <= 2) {
        this.nextBtn.addClass('is-disabled');
      }
    } else if (this.mobileViewport.matches) {
      this.itemsPerPage = 1;

      if(this.items.length <= 1) {
        this.nextBtn.addClass('is-disabled');
      }
    }

    this.desktopViewport.addListener(mq => {
      if (mq.matches) {
        this.setItemsPerPage(4);

        if(this.items.length <= 4) {
          this.nextBtn.addClass('is-disabled');
        }
      }
    });

    this.tabletViewport.addListener(mq => {
      if (mq.matches) {
        this.setItemsPerPage(2);

        if(this.items.length <= 2) {
          this.nextBtn.addClass('is-disabled');
        }
      }
    });

    this.mobileViewport.addListener(mq => {
      if (mq.matches) {
        this.setItemsPerPage(1);

        if(this.items.length <= 1) {
          this.nextBtn.addClass('is-disabled');
        }
      }
    });
  }

  updateViewports (type) {
    if (this.currentViewport !== type) {
      this.list = this.gallerySliderWrapper.find('.slider-gallery-small-list');
      this.currentItem = 0;
      this.list.css('margin-left', "0%");
      this.currentViewport = type;
    }
  }

  setItemsPerPage (numberOfItems) {
    this.currentItem = 0;
    this.itemsPerPage = numberOfItems;
    this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
  }
}